const userConst = {
  color: '2d96b4',
};

export default userConst;
